export default [
    {src:require('./logos/logoUnal.png'), href:'http://unal.edu.co'},
    {src:require('./logos/logoCorpocaldas.png'), href:'http://www.corpocaldas.gov.co'},
    {src:require('./logos/logoAlcaldia.png'), href:'http://www.manizales.gov.co'},
    {src:require('./logos/logoGobernacion.png'), href:'https://caldas.gov.co'},
    {src:require('./logos/logoAguas.png'), href:'http://www.aguasdemanizales.com.co'},
    {src:require('./logos/logoChec.png'), href:'http://www.chec.com.co'},
    {src:require('./logos/logoEmas.png'), href:'http://veoliacaldas.esmartserver.com'},
    {src:require('./logos/logoGaia.svg'), href:'http://froac.manizales.unal.edu.co/GAIA/index.php'},
    {src:require('./logos/logoGta.png'), href:'http://idea.manizales.unal.edu.co/gta/ingenieria_hidraulica'},
    {src:require('./logos/logoGestion.png'), href:'http://www.gestiondelriesgomanizales.com'}
]